import { IGetPriceProductsService } from "@modules/orders/models/IGetPriceProductsService";
import { safeExecute } from "@utils/safeExecute";

interface PriceRequest {
  addressID: string;
  customerID: string;
  deadlinePayment: number;
  filialID: string;
  productID: string;
  transportationZone: string;
}

export function fetchProductPrice(
  service: IGetPriceProductsService,
  params: PriceRequest
) {
  return safeExecute(
    () => service.execute(params),
    "Ocorreu um erro ao consultar preço, tente novamente"
  );
}
